<form [formGroup]="asesorForm">
  <div class="bg-blue-2 d-flex al-center sp-between p-4">
    <div>
      <div>
        <span class="text-white fw-extrabold fs-4">{{ data && data.userId ? 'Editar' : 'Nuevo'}} {{ rol == 1 ? 'asesor': 'cliente'}}</span>
      </div>
      <div *ngIf="!data">
        <span class="text-white fs-6 fw-regular">Crea nuevo {{ rol == 1 ? 'asesor': 'cliente'}}</span>
      </div>
    </div>
    <div>
      <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
    </div>
  </div>
  <mat-dialog-content class="p-5 d-flex flex-column content-form">
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Nombres y apellidos (Obligatorio)</span>
      </div>
      <input nz-input formControlName="fullname" placeholder="Ingrese nombres y apellidos del cliente" class="w-100" />
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">País (Obligatorio)</span>
      </div>
      <nz-select class="w-100" formControlName="country" nzPlaceHolder="Busque país de residencia">
        <nz-option [nzValue]="c.id" [nzLabel]="c.descripcion" *ngFor="let c of countries"></nz-option>
      </nz-select>
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Ciudad (Obligatorio)</span>
      </div>
      <input nz-input formControlName="city" placeholder="Ingrese ciudad de residencia" class="w-100" />
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Dirección</span>
      </div>
      <input nz-input formControlName="address" placeholder="Ingrese dirección de residencia" class="w-100" />
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Número telefónico</span>
      </div>
      <input nz-input formControlName="phone" maxlength="13" (keypress)="keypressNumbers($event)"
        placeholder="Número telefónico" class="w-100" />
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Correo electrónico (Obligatorio)</span>
      </div>
      <input nz-input formControlName="email" placeholder="Ingrese correo electrónico" class="w-100" />
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Fecha de nacimiento</span>
      </div>
      <input nz-input formControlName="fecnac" placeholder="dd/mm/aaaa" maxlength="10" class="w-100" />
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Rango</span>
      </div>
      <nz-select class="w-100" formControlName="range" nzPlaceHolder="Escoja el rango al que pertenece el asesor">
        <nz-option [nzValue]="range.id" [nzLabel]="range.descripcion" *ngFor="let range of ranges"></nz-option>
      </nz-select>
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Tipo de documento</span>
      </div>
      <nz-select class="w-100" formControlName="typeDoc" nzPlaceHolder="Escoja el tipo de documento">
        <nz-option [nzValue]="document.id" [nzLabel]="document.descripcion"
          *ngFor="let document of documents"></nz-option>
      </nz-select>
    </div>
    <div>
      <div>
        <span class="fs-6 fw-semibold text-black">Número de documento</span>
      </div>
      <input nz-input formControlName="numberDocument" placeholder="Ingrese número de documento" class="w-100" />
    </div>
    <div>
      <!-- <div>
        <span class="fs-6 fw-semibold text-black">Permisos especiales</span>
      </div> -->
      <div class="row">
        <div class="col-sm-6">
          <label nz-checkbox formControlName="permits" class="me-2"></label>
          <span class="fs-6 fw-semibold text-black">Permisos especiales</span>
        </div>
      </div>
    </div>
    <div *ngIf="hasSpecialPermits">
      <div>
        <span class="fs-6 fw-semibold text-black">Plan (Obligatorio)</span>
      </div>
      <nz-select class="w-100" formControlName="plans" nzPlaceHolder="Escoja el tipo de plan">
        <nz-option [nzValue]="item.id" [nzLabel]="item.titulo" *ngFor="let item of plans"></nz-option>
      </nz-select>
    </div>
  </mat-dialog-content>
  <div class="p-4 text-end content-action">
    <mat-dialog-actions align="end">
      <button mat-flat-button al class="bg-blue-2" (click)="saveUser()" [disabled]="!asesorForm.valid">
        <span class="fw-bold fs-5 text-white me-3">{{ data && data.userId ? 'Actualizar' : 'Crear'}} {{ rol == 1 ? 'asesor': 'cliente'}}</span>
        <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
      </button>
    </mat-dialog-actions>
  </div>
</form>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>